import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_TableList, {
      ref: "TableList",
      dataList: _ctx.list,
      total: _ctx.total,
      columnAllData: _ctx.columnAllData,
      tableName: _ctx.TableName,
      permissionName: _ctx.permissionName,
      showSelection: false,
      canRefresh: false,
      canChangeColumn: false,
      canCommand: false,
      showSummary: true,
      isShowPagination: false,
      onCommandChange: _ctx.handleCommand
    }, null, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "onCommandChange"]), [
      [_directive_loading, _ctx.listLoading]
    ])
  ], 512)), [
    [_vShow, !_ctx.dialogFormVisible]
  ])
}